import * as React from "react";
const SvgTriangle = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 8,
	height: 6,
	viewBox: "0 0 8 6",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M4.43685 5.78571C4.2427 6.07143 3.75731 6.07143 3.56315 5.78571L0.0683346 0.642856C-0.125822 0.357142 0.116873 -6.89165e-07 0.505186 -6.55218e-07L7.49481 -4.41647e-08C7.88313 -1.02174e-08 8.12582 0.357143 7.93167 0.642857L4.43685 5.78571Z",
	fill: "#626671"
}));
export default SvgTriangle;
